<!--suppress ALL -->
<script>
  import { fade, fly } from "svelte/transition";
  import numeral from "numeral";
  import Papa from "papaparse";
  //import materials from "./products.js";
  //import materialsmisc from "./productsmisc.js";
  import quantities from "./quantities.js";
  import quantitiesmisc from "./quantitiesmisc.js";
  import zones from "./zones.js";
  //import Button from "./ui/Button.svelte";
  import { onMount } from "svelte";
  import { jsPDF } from "jspdf";
  import "jspdf-autotable";
  import domtoimage from 'dom-to-image'
  import { getNotificationsContext } from 'svelte-notifications';

  const { addNotification } = getNotificationsContext();

  let future = new Date();
  let validUntil = new Date(future.setDate(future.getDate() + 30)).toLocaleDateString()
  let d = new Date();
  let fullyear = d.getFullYear();
  let version = "2026.05.07.a";
  let isValid = false;
  let address1 = "";
  let address2 = "";
  let addressfound = false;
  let city = "";
  let invalidAddress = false;
  let product1 = "";
  let invalidProduct1 = false;
  let product2 = "";
  let invalidProduct2 = false;
  let product1quantity = 1.0;
  let invalidQuantity1 = false;
  let product2quantity = 1.0;
  let invalidQuantity2 = false;
  let product3 = "";
  let product3quantity = 1.0;
  let notes = "";
  let deliveryzone = "";
  let addressnotfound = "";
  let showMap = false;
  let result = "";
  let confirmed = false;
  let singleloads = 0;
  let splitloads = 0;
  let lat;
  let lng;
  let zoneinfo = "";
  let map;
  let pol;
  let googleready = false;
  let isbagged = false;
  let totalbags = 0;
  let palletdeposit = 35.0;
  let bagdelivery = 31.88;
  let bagcost = 25.0;
  let fillcharge = 20.0;
//let halfmaxheavy = 2.5;
  let halfmaxheavy = 2;
  let halfmaxlight = 3.5;
  let p1heavy = false;
  let p2heavy = false;
  let pricelevel = 1;
  let history = [];
  let selectedhistory = "";
  let savedplace = null;
  let terms =
    "Quoted prices are valid for the above quantities.  Any change in the quantity may invalidate the pricing.  Prices are valid on all products shipped prior to " +
    validUntil +
    ".";

  // Get list of bulk materials with pricing
  let materials = []
  Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vRRfwUFfxU5uC83ktmDtB0kPpmE0-xeJitrTWMvjyGCt0nd7kHLsxjm19U6eAyezTZ-m-cZqaEDWcRu/pub?output=csv", {
    download: true,
    header: true,
    complete: (results) => {
      materials = Array.from(results.data).filter(item => item.active === "1");
    },
  });

  // Get list of misc materials with pricing
  let materialsmisc = []
  Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vQXAcpwQDDJoVHXbMMNxpv5BBlWgOmTIMqsNiwyRQry-9KJpby7PxXmA6bf1GBwYGGOAM513bXBVdGF/pub?output=csv", {
    download: true,
    header: true,
    complete: (results) => {
      materialsmisc = Array.from(results.data).filter(item => item.active === "1");
    },
  });

  // Get fuel surcharge
  let surchargerate = 0.1
  let surchargetext = "10% Fuel Surcharge"
  Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vT9Ca1bvd0mOSrfeZssNnYp4TLCldlPG8xw7UmkK-UXY-GEVQmssjj3B2yuhu47d12b1FhFJ_o4S2gF/pub?output=csv", {
    download: true,
    header: true,
    complete: (results) => {
      surchargerate = Array.from(results.data)[0].rate;
      surchargetext = Array.from(results.data)[0].text;
    },
  });

  $: errs = [];
  $: p1index = findWithAttr(materials, "name", product1);
  $: p2index = findWithAttr(materials, "name", product2);
  $: p3index = findWithAttr(materialsmisc, "name", product3);
  $: p1max = product1 === "" ? 0 : materials[p1index].qty;
  $: p2max = product2 === "" ? 0 : materials[p2index].qty;
  $: unitprice1 = product1 === "" ? 0 : materials[p1index].price * pricelevel;
  $: unitprice2 = product2 === "" ? 0 : materials[p2index].price * pricelevel;
  $: unitprice3 =
    product3 === "" ? 0 : materialsmisc[p3index].price * pricelevel;
  $: product1price =
    (product1 === "" ? 0 : materials[p1index].price * pricelevel) *
    product1quantity;
  $: product1pst =
    product1 === ""
      ? 0
      : (materials[p1index].tax === '2' ? 0.07 : 0) * product1price;
  $: product2price =
    (product2 === "" ? 0 : materials[p2index].price * pricelevel) *
    product2quantity;
  $: product2pst =
    product2 === ""
      ? 0
      : (materials[p2index].tax === '2' ? 0.07 : 0) * product2price;
  $: product3price =
    (product3 === "" ? 0 : materialsmisc[p3index].price * pricelevel) *
    product3quantity;
  $: product3pst =
    product3 === ""
      ? 0
      : (materialsmisc[p3index].tax === '2' ? 0.07 : 0) * product3price;
  $: values = calcLoads(
    product1quantity,
    product2quantity,
    product1,
    product2,
    isbagged
  );
  $: singletotal = values.single * deliverysingle;
  $: splittotal = values.split * deliverysplit;
  $: deliverybagged = calcBags(product1quantity, product2quantity, isbagged);
  $: delivery = singletotal + splittotal + deliverybagged;
  $: deliverySurcharge = delivery * surchargerate;
  $: deliverypst = delivery * 0.07;
  $: surchargePst = deliverySurcharge * 0.07;
  $: bagtotal = totalbags * bagcost;
  $: bagpst = bagtotal * 0.07;
  $: filltotal = totalbags * fillcharge;
  $: pallettotal = totalbags * palletdeposit;
  $: subtotal2 =
    product1price +
    product2price +
    product3price +
    bagtotal +
    filltotal +
    delivery +
    deliverySurcharge;
  $: gst = subtotal2 * 0.05;
  $: subtotal = subtotal2 + pallettotal;
  $: pst = product1pst + product2pst + product3pst + bagpst + deliverypst + surchargePst;
  $: totalprice = subtotal + gst + pst;

  $: gready = googleready;

  let placeSearch;
  let autocomplete = false;

  let deliverycrane = 0.0;
  let deliverysingle = 0.0;
  let deliverysplit = 0.0;

  onMount(() => {
    //console.log("mounted");
    autocomplete = new google.maps.places.Autocomplete(
      document.getElementById("autocomplete"),
      { types: ["geocode"] }
    );
    autocomplete.setFields(["address_component", "geometry"]);
    autocomplete.addListener("place_changed", fillInAddress);

    if (autocomplete) {
      googleready = true;
      document.getElementById("autocomplete").focus();
      console.log("Google ready");
    }
  });

  let logo =
    "data:image/png;base64,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";
  let printterms = "© " + fullyear + " Landscape Centre Inc. - " + version;

  function printQuote(o) {
    let title = "bulk-quote- " + address2;
    let doc = new jsPDF("p", "mm", "letter");
    doc.setProperties({
      title: title,
      subject: title,
      author: "Landscape Centre Inc.",
      keywords: "bulk quote",
      creator: "Landscape Centre Inc.",
    });
    if (o === "print") {
      doc.autoPrint({ variant: "non-conform" });
    }
    doc.addImage(logo, "png", 13.5, 15);
    doc.setFontSize(18);
    doc.text("Landscape Centre Inc.", 50, 21);
    //doc.text("Bulk Materials Quote", 142, 21);
    doc.setFontSize(10);
    doc.text(
      "604-540-0333 | sales@landscapecentre.com | landscapecentre.com",
      50,
      27
    );
    doc.setDrawColor("#236e21");
    doc.line(14, 31, 202, 31);
    doc.setFontSize(12);
/*     doc.text(
      "Delivery Address: " + address2 + " (" + deliveryzone + ")",
      14,
      37
    );
    doc.text(notes, 14, 44); */
    doc.autoTable({ startY: 37, html: "#order-details", useCss: true });
    let finalY = doc.previousAutoTable.finalY;

    /* doc.setFontSize(8)
    let splitterms = doc.splitTextToSize(terms, 180);
    doc.text(splitterms, 14, finalY + 5) */

    doc.setDrawColor("#236e21");
    doc.line(14, finalY + 2, 202, finalY + 2);
    doc.setFontSize(7);
    //doc.text(printterms, 14, finalY + 5, { align: "left" });

    let fname = "bulk-quote- " + address2 + ".pdf";
    

    if (o === "print") {
      doc.output("dataurlnewwindow", { filename: fname });
    } else if (o === "save") {
      doc.save(fname);

      addNotification({
        text: 'Quote downloaded as a PDF',
        position: 'bottom-right',
        type: 'success',
        removeAfter: 3000,
      })
    }
  }

/*   function filter(node) {
    return (node !=== document.getElementById('buttons'));
  } */

  async function saveAsImage() {
    let fname2 = "bulk-quote- " + address2 + ".jpg";
    domtoimage.toJpeg(document.getElementById('order-details'), { quality: 1.0 })
      .then(function (dataUrl) {
          var link = document.createElement('a');
          link.download = fname2;
          link.href = dataUrl;
          link.click();

          addNotification({
            text: 'Quote downloaded as an image',
            position: 'bottom-right',
            type: 'success',
            removeAfter: 3000,
          })
      });
  }
  

  async function fillInAddress() {
    result = "";
    var place = autocomplete.getPlace();
    savedplace = place;
    //console.log(place.address_components)
    let streetnum = "";
    let streetname = "";

    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      if (addressType === "locality") {
        city = place.address_components[i].short_name;
      }
      if (addressType === "street_number") {
        streetnum = place.address_components[i].short_name;
      }
      if (addressType === "route") {
        streetname = place.address_components[i].short_name;
      }
    }

    address1 = streetnum + " " + streetname;
    address2 = streetnum + " " + streetname + ", " + city;
    lat = place.geometry.location.lat();
    lng = place.geometry.location.lng();

    zoneinfo = await getArea(lat, lng);

    if (addressfound) {
      map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: lat, lng: lng },
        zoom: 11,
        disableDefaultUI: false,
      });

      let marker = new google.maps.Marker({
        position: place.geometry.location,
        map: map,
        animation: google.maps.Animation.DROP,
      });

      pol.setMap(map);
    }
  }

  async function fillInAddress2(p) {
    result = "";
    var place = p;
    //console.log(place.address_components)
    let streetnum = "";
    let streetname = "";

    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      if (addressType === "locality") {
        city = place.address_components[i].short_name;
      }
      if (addressType === "street_number") {
        streetnum = place.address_components[i].short_name;
      }
      if (addressType === "route") {
        streetname = place.address_components[i].short_name;
      }
    }

    address1 = streetnum + " " + streetname;
    address2 = streetnum + " " + streetname + ", " + city;
    lat = place.geometry.location.lat();
    lng = place.geometry.location.lng();

    zoneinfo = await getArea(lat, lng);

    if (addressfound) {
      map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: lat, lng: lng },
        zoom: 11,
        disableDefaultUI: false,
      });

      let marker = new google.maps.Marker({
        position: place.geometry.location,
        map: map,
        animation: google.maps.Animation.DROP,
      });

      pol.setMap(map);

      product1quantity = 1;
      product2quantity = 1;
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////

  function geolocate() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        var circle = new google.maps.Circle({
          center: geolocation,
          radius: position.coords.accuracy,
        });
        autocomplete.setBounds(circle.getBounds());
      });
    }
  }
  /////////////////////////////////////////////////////////////////////////////////////////

  async function getArea(nlat, nlng) {
    let point = new google.maps.LatLng(nlat, nlng);
    let b = false;

    for (var i = 0; i < zones.length; i += 1) {
      pol = new google.maps.Polygon({
        paths: zones[i].bounds,
        strokeColor: "#056839",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#056839",
        fillOpacity: 0.35,
      });
      if (google.maps.geometry.poly.containsLocation(point, pol)) {
        b = true;
      }

      if (b === true) {
        deliverycrane = zones[i].crane;
        deliverysingle = zones[i].dump;
        deliverysplit = zones[i].split;
        deliveryzone = zones[i].name;
        addressfound = true;

        addressnotfound = "";
        return (
          zones[i].name +
          " (Dump: " +
          numeral(zones[i].dump).format("$0.00") +
          " | Split: " +
          numeral(zones[i].split).format("$0.00") +
          ")"
        );
      }
    }

    if (b === false) {
      deliverycrane = 0.0;
      deliverysingle = 0.0;
      deliverysplit = 0.0;
      document.getElementById("autocomplete").value = "";
      addressfound = false;
      addressnotfound = "🙁 ADDRESS IS NOT WITHIN OUR DELIVERY AREA";
      return "🙁 ADDRESS IS NOT WITHIN OUR DELIVERY AREA";
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////

  function saveQuote() {
    // Check to see if address is already in history and if it is, update it
    let historyindex = findWithAttr(history, "address2", address2);

    if (historyindex > -1) {
      // Address already exists in history so update the values
      history[historyindex].product1 = product1;
      history[historyindex].product1quantity = product1quantity;
      history[historyindex].product2 = product2;
      history[historyindex].product2quantity = product2quantity;
      history[historyindex].pricelevel = pricelevel;
      history[historyindex].isbagged = isbagged;
      history[historyindex].notes = notes;
    } else {
      // Address not in history so add address to history
      let quote = {
        googleaddress: document.getElementById("autocomplete").value,
        place: savedplace,
        address1: address1,
        address2: address2,
        product1: product1,
        product1quantity: product1quantity,
        product2: product2,
        product2quantity: product2quantity,
        isbagged: isbagged,
        pricelevel: pricelevel,
        notes: notes,
      };

      history = [...history, quote];
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////

  async function loadSavedQuote() {
    let historyindex = findWithAttr(history, "address2", selectedhistory);

    address1 = history[historyindex].address1;
    address2 = history[historyindex].address2;
    document.getElementById("autocomplete").value =
      history[historyindex].googleaddress;

    let p = history[historyindex].place;

    await fillInAddress2(p);

    isbagged = history[historyindex].isbagged;
    pricelevel = history[historyindex].pricelevel;
    product1 = history[historyindex].product1;
    product1quantity = history[historyindex].product1quantity;
    product2 = history[historyindex].product2;
    product2quantity = history[historyindex].product2quantity;
    notes = history[historyindex].notes;

    await calcLoads();
  }

  /////////////////////////////////////////////////////////////////////////////////////////

  function resetAddress() {
    saveQuote();

    deliverycrane = 0.0;
    deliverysingle = 0.0;
    deliverysplit = 0.0;
    document.getElementById("autocomplete").value = "";
    addressfound = false;
    address1 = "";
    address2 = "";
    city = "";
    product1 = "";
    product2 = "";
    product3 = "";
    product1quantity = 1.0;
    product2quantity = 1.0;
    product3quantity = 1.0;
    //paymentmethod = '';
    //ccnum = '';
    //ccexpiry = '';
    //cccvv = '';
    //ccname = '';
    //invalidCCnum = false;
    //invalidCCexpiry = false;
    //invalidCCname = false;
    //invalidCCcvv = false;
    notes = "";
    singleloads = 0;
    splitloads = 0;
    deliverysingle = 0.0;
    deliverysplit = 0.0;
    zoneinfo = "";
    map = "";
    isbagged = false;
    totalbags = 0;
    addressnotfound = "";
    errs = [];
    isValid = true;
    result = "";
    invalidAddress = false;
    invalidProduct1 = false;
    invalidQuantity1 = false;
    invalidQuantity2 = false;
    pricelevel = 1;
    document.getElementById("autocomplete").focus();
  }

  /////////////////////////////////////////////////////////////////////////////////////////

  function calcBags(p1, p2, b) {
    if (!b) {
      totalbags = 0;
      //console.log("Not bagged")
      return 0;
    }

    //console.log("Bagged")
    singleloads = 0;
    splitloads = 0;

    if (product2 === "") {
      p2 = 0;
    }

    totalbags = Math.round(p1) + Math.round(p2);
    let bypallet = totalbags * bagdelivery;

    if (bypallet < deliverycrane) {
      return deliverycrane;
    } else {
      return bypallet;
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////

  function calcLoads(p1, p2, prod1, prod2, b) {
    if (b) {
      return { single: 0, split: 0 };
    }

    if (prod1 === "") {
      product1quantity = 1;
      product2quantity = 1;
      product2 = "";
      return { single: 0, split: 0 };
    }

    if (prod2 === "") {
      product2quantity = 1;
      p2 = 0;
    }

    totalbags = 0;
    let fullLoads = 0;
    let halfLoads = 0;
    let halfmaxheavy = 2.5;
    let halfmaxlight = 4;
    let p1heavy = false;
    let p2heavy = false;
    let p1halfqty = 0;
    let p2halfqty = 0;

    if (p1 > 0) {
      if (p1 >= p1max) {
        let x = p1 / p1max;
        let n = x; //parseFloat((Math.ceil(x / 0.5) * 0.5).toFixed(1))
        //console.log("Full Loads P1" + Math.floor(n))
        if (n % 1 > 0) {
          fullLoads = Math.floor(n);
          halfLoads = 1;
          p1halfqty = p1 - fullLoads * p1max;
          if (p1max === 5) {
            p1heavy = true;
          }
        } else {
          fullLoads = n;
          halfLoads = 0;
          p1halfqty = 0;
        }
      } else {
        if (p1max === 5) {
          p1heavy = true;
          halfLoads = 1;
          fullLoads = 0;
          p1halfqty = p1;
        } else {
          p1heavy = false;
          halfLoads = 1;
          fullLoads = 0;
          p1halfqty = p1;
        }
      }
      //}
    }

    if (p2 > 0) {
      //if(p1max === 4.5) {
      if (p2 >= p2max) {
        let x2 = p2 / p2max;
        let n2 = x2; //parseFloat((Math.ceil(x2 / 0.5) * 0.5).toFixed(1))
        if (n2 % 1 > 0) {
          fullLoads = fullLoads + Math.floor(n2);
          halfLoads = halfLoads + 1;
          p2halfqty = p2 - Math.floor(n2) * p2max;

          if (p2max === 5) {
            p2heavy = true;
          }
        } else {
          fullLoads = fullLoads + n2;
          p2halfqty = 0;
        }
      } else {
        if (p2max === 5) {
          p2heavy = true;
          halfLoads = halfLoads + 1;
          p2halfqty = p2;
        } else {
          p2heavy = false;
          halfLoads = halfLoads + 1;
          p2halfqty = p2;
        }
      }
      //}
    }

    //console.log("Half Loads = " + halfLoads)
    //console.log("P1 Heavy = " + p1heavy)
    //console.log("P2 Heavy = " + p2heavy)

    if (halfLoads === 2) {
      if (p1heavy && p2heavy) {
        if (p1halfqty + p2halfqty > 5) {
          fullLoads = fullLoads + 1;
          halfLoads = 1;
        }
      }

      if (p1heavy && !p2heavy) {
        if (p1halfqty > 4) {
          fullLoads = fullLoads + 1;
          halfLoads = 1;
        } else if (p2halfqty > 4) {
          fullLoads = fullLoads + 1;
          halfLoads = 1;
        } else if (p1halfqty + p2halfqty > 7.5) {
          fullLoads = fullLoads + 1;
          halfLoads = 1;
        }
      }

      if (!p1heavy && p2heavy) {
        if (p2halfqty > 4) {
          fullLoads = fullLoads + 1;
          halfLoads = 1;
        } else if (p1halfqty > 4) {
          fullLoads = fullLoads + 1;
          halfLoads = 1;
        } else if (p1halfqty + p2halfqty > 7.5) {
          fullLoads = fullLoads + 1;
          halfLoads = 1;
        }
      }

      if (!p1heavy && !p2heavy) {
        if (p2halfqty > p2max / 2) {
          fullLoads = fullLoads + 1;
          halfLoads = 1;
        } else if (p1halfqty > p1max / 2) {
          fullLoads = fullLoads + 1;
          halfLoads = 1;
        } else if (p1halfqty + p2halfqty > 8) {
          fullLoads = fullLoads + 1;
          halfLoads = 1;
        }
      }
    }

    if (halfLoads === 2 && fullLoads === 0) {
      singleloads = 0;
      splitloads = 1;
      //console.log({single: 0, split: 1})
      return { single: 0, split: 1 };
    } else if (halfLoads === 1 && fullLoads > 0) {
      singleloads = fullLoads + 1;
      splitloads = 0;
      //console.log({single: fullLoads + 1, split: 0})
      return { single: fullLoads + 1, split: 0 };
    } else if (halfLoads === 2 && fullLoads > 0) {
      singleloads = fullLoads;
      splitloads = 1;
      //console.log({single: fullLoads, split: 1})
      return { single: fullLoads, split: 1 };
    } else if (halfLoads === 1 && fullLoads === 0) {
      singleloads = 1;
      splitloads = 0;
      //console.log({single: 1, split: 0})
      return { single: 1, split: 0 };
    } else if (halfLoads === 0 && fullLoads > 0) {
      singleloads = fullLoads;
      splitloads = 0;
      //console.log({single: 1, split: 0})
      return { single: fullLoads, split: 0 };
    } else {
      return { single: 0, split: 0 };
    }
  }

  /////////////////////////////////////////////////////////

  function findWithAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
      if (array[i][attr] === value) {
        return i;
      }
    }
    return -1;
  }

  /////////////////////////////////////////////////////////

  function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  //////////////////////////////////////////////////////////////

  function validateCardNumber(number) {
    return luhnCheck(number.replace(/\s+/g, ""));
  }

  //////////////////////////////////////////////////////////////

  function copyTable(el) {
      var body = document.body, range, sel;
      if (document.createRange && window.getSelection) {
          range = document.createRange();
          sel = window.getSelection();
          sel.removeAllRanges();
          try {
              range.selectNodeContents(el);
              sel.addRange(range);
          } catch (e) {
              range.selectNode(el);
              sel.addRange(range);
          }
          document.execCommand("copy");

          clearSelection()
        
      } else if (body.createTextRange) {
          range = body.createTextRange();
          range.moveToElementText(el);
          range.select();
          range.execCommand("Copy");

          clearSelection()

      }
  }

  function clearSelection() {
    if (window.getSelection) {window.getSelection().removeAllRanges();}
    else if (document.selection) {document.selection.empty();}

    addNotification({
      text: 'Quote copied to clipboard',
      position: 'bottom-right',
      type: 'success',
      removeAfter: 3000,
    })
  }

  function getDate () {
    let dt = new Date()
    return dt.toDateString() + ' ' + dt.toLocaleTimeString()
  }

  //////////////////////////////////////////////////////////////

  function copyQuote() {
    if (!navigator.clipboard) {
      // Clipboard API not available
      return;
    }
    const text = createTable();
    try {
      navigator.clipboard.writeText(text);
      console.log("Copied to clipboard");
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  }

  ///////////////////////////////////////////////////////////////
  function createTable() {
    let p2 = "";
    if (product2 != "") {
      p2 =
        "<tr>" +
        '<td style="padding: 5px; border: 1px solid #ccc;">' +
        product2 +
        "</td>" +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        product2quantity +
        "</td>" +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        numeral(product2price).format("$0,0.00") +
        "</td>" +
        "</tr>";
    }
    let sur = ''
    if (deliverySurcharge != 0) {
      sur =
              "<tr>" +
              '<td style="padding: 5px; border: 1px solid #ccc;">' +
              "FUEL SURCHARGE @ " + {surchargetext} +
              "</td>" +
              '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
              "-" +
              "</td>" +
              '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
              numeral(deliverySurcharge).format("$0,0.00") +
              "</td>" +
              "</tr>";
    }
    let single = "";
    if (singleloads > 0) {
      single =
        "<tr>" +
        '<td style="padding: 5px; border: 1px solid #ccc;"> Delivery Single @ ' +
        numeral(deliverysingle).format("$0,0.00") +
        "</td>" +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        singleloads +
        "</td>" +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        numeral(singletotal).format("$0,0.00") +
        "</td>" +
        "</tr>";
    }
    let split = "";
    if (splitloads > 0) {
      split =
        "<tr>" +
        '<td style="padding: 5px; border: 1px solid #ccc;"> Delivery Split @ ' +
        numeral(deliverysplit).format("$0,0.00") +
        "</td>" +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        splitloads +
        "</td>" +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        numeral(splittotal).format("$0,0.00") +
        "</td>" +
        "</tr>";
    }
    let bags = "";
    if (totalbags > 0) {
      bags =
        "<tr>" +
        '<td style="padding: 5px; border: 1px solid #ccc;"> Bags @ ' +
        numeral(bagcost).format("$0,0.00") +
        "</td>" +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        totalbags +
        "</td>" +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        numeral(bagtotal).format("$0,0.00") +
        "</td>" +
        "</tr>" +
        "<tr>" +
        '<td style="padding: 5px; border: 1px solid #ccc;"> Fill Charge @ ' +
        numeral(fillcharge).format("$0,0.00") +
        "</td>" +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        totalbags +
        "</td>" +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        numeral(filltotal).format("$0,0.00") +
        "</td>" +
        "</tr>" +
        "<tr>" +
        '<td style="padding: 5px; border: 1px solid #ccc;"> Pallet Deposit @ ' +
        numeral(palletdeposit).format("$0,0.00") +
        "</td>" +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        totalbags +
        "</td>" +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        numeral(pallettotal).format("$0,0.00") +
        "</td>" +
        "</tr>" +
        "<tr>" +
        '<td style="padding: 5px; border: 1px solid #ccc;">Delivery Crane/Forklift</td>' +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;"></td>' +
        '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
        numeral(delivery).format("$0,0.00") +
        "</td>" +
        "</tr>";
    }
    let tb =
      '<table style="box-sizing: inherit; border-collapse: collapse; border-spacing: 0px; background-color: rgb(255, 255, 255); color: rgb(54, 54, 54); font-family: arial, sans-serif; width: 450px; margin-bottom: 1.5rem;">' +
      '<tbody style="background-color: transparent;">' +
      "<tr>" +
      '<td colspan="3" style="padding: 5px; border: 1px solid #ccc;"><b>Customer Information</b></td>' +
      "</tr>" +
      "<tr>" +
      '<td style="padding: 5px; border: 1px solid #ccc;"><b>Address:</b></td>' +
      '<td colspan="2" style="padding: 5px; border: 1px solid #ccc;">' +
      address2 +
      "</td>" +
      "</tr>" +
      "<tr>" +
      '<td style="padding: 5px; border: 1px solid #ccc;"><b>Delivery Zone:</b></td>' +
      '<td colspan="2" style="padding: 5px; border: 1px solid #ccc;">' +
      deliveryzone +
      "</td>" +
      "</tr>" +
      "<tr>" +
      '<td colspan="3" style="border: 1px solid #ccc;"></td>' +
      "</tr>" +
      "<tr>" +
      '<td colspan="3" style="padding: 5px; border: 1px solid #ccc;"><b>Quote Details</b></td>' +
      "</tr>" +
      "<tr>" +
      '<td style="padding: 5px; border: 1px solid #ccc;"><b>Description</b></td>' +
      '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;"><b>Quantity</b></td>' +
      '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;"><b>Amount</b></td>' +
      "</tr>" +
      "<tr>" +
      '<td style="padding: 5px; border: 1px solid #ccc;">' +
      product1 +
      "</td>" +
      '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
      product1quantity +
      "</td>" +
      '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
      numeral(product1price).format("$0,0.00") +
      "</td>" +
      "</tr>" +
      p2 +
      single +
      split +
      bags + sur +
      "<tr>" +
      '<td colspan="2" style="padding: 5px; border: 1px solid #ccc; text-align: right;"><b>Subtotal:</b></td>' +
      '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;"><b>' +
      numeral(subtotal).format("$0,0.00") +
      "</b></td>" +
      "</tr>" +
      "<tr>" +
      '<td colspan="2" style="padding: 5px; border: 1px solid #ccc; text-align: right;"><b>GST:</b></td>' +
      '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
      numeral(gst).format("$0,0.00") +
      "</td>" +
      "</tr>" +
      "<tr>" +
      '<td colspan="2" style="padding: 5px; border: 1px solid #ccc; text-align: right;"><b>PST:</b></td>' +
      '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;">' +
      numeral(pst).format("$0,0.00") +
      "</td>" +
      "</tr>" +
      "<tr>" +
      '<td colspan="2" style="padding: 5px; border: 1px solid #ccc; text-align: right;"><b>Total:</b></td>' +
      '<td style="padding: 5px; border: 1px solid #ccc; text-align: right;"><b>' +
      numeral(totalprice).format("$0,0.00") +
      "</b></td>" +
      "</tr>" +
      "<tr>" +
      '<td colspan="3" style="border: 1px solid #ccc;"></td>' +
      "</tr>" +
      "</tbody>" +
      "</table>";

    return tb;
  }
  /////////////////////////////////////////////////////////////////////////////////////////
</script>

<style>
  :global(.main__checkbox) {
    margin: 0.5rem;
  }

  .button-color {
    color: #056839;
  }

  hr {
    margin-top: 0.4em;
    margin-bottom: 0.4em;
  }
  .mainContainer {
    display: flex;
    flex-wrap: wrap;
    padding: 1px;
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 15px;
    max-width: 1700px;
    /* margin: auto; */
  }

  .mainContainer2 {
    display: flex;
    flex-wrap: wrap;
    padding: 1px;
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 2px;
    max-width: 1700px;
    /* margin: auto; */
  }

  .sectionContainer {
    padding: 8px;
    margin: 5px;
    border: solid 1px #c5c3c3;
    border-top: solid 10px rgb(243, 139, 3);
    border-radius: 8px;
    box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -moz-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -webkit-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -o-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    min-width: 390px;
    max-width: 390px;
    align-items: left;
    background-color: #fcf8f8;
  }

  .sectionContainer2 {
    padding: 5px;
    margin: 5px;
    border: solid 1px #c5c3c3;
    border-top: solid 10px rgb(3, 135, 243);
    border-radius: 8px;
    box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -moz-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -webkit-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -o-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    min-width: 390px;
    max-width: 390px;
    align-items: left;
    background-color: #fcf8f8;
  }

  .sectionContainer3 {
    padding: 5px;
    margin: 5px;
    border: solid 1px #c5c3c3;
    border-top: solid 10px rgb(5, 161, 5);
    border-radius: 8px;
    box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -moz-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -webkit-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -o-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    min-width: 390px;
    max-width: 390px;
    align-items: left;
    background-color: #fcf8f8;
  }

  .mapContainer {
    padding: 0px;
    margin: 5px;
    border: solid 1px #c5c3c3;
    border-top: solid 10px rgb(243, 139, 3);
    border-radius: 8px;
    box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -moz-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -webkit-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -o-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    min-width: 390px;
    max-width: 390px;
    min-height: 300px;
    height: auto;
    align-items: left;
  }

  @media (max-width: 830px) {
    .sectionContainer {
      max-width: 95%;
      min-width: 95%;
      align-items: left;
    }

    .mapContainer {
      max-width: 95%;
      min-width: 95%;
      height: 390px;
      align-items: left;
    }

    .mainContainer {
      max-width: 97%;
      min-width: 97%;
      margin: auto;
      margin-top: 15px;
    }

    .mainContainer2 {
      max-width: 97%;
      min-width: 97%;
      margin: auto;
      margin-top: 2px;
    }
  }

  .submitContainer {
    padding: 10px;
    margin: 5px;
    border: solid 1px #f0eded;
    border-radius: 4px;
    box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -moz-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -webkit-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    -o-box-shadow: 2px 2px 2px rgba(218, 217, 217, 0.6);
    max-width: 95%;
    min-width: 95%;
  }

  .sectionTitle {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 1.1rem;
    color: #056839;
    padding: 5px;
  }

  .sectionTitle2 {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 0.8rem;
    color: #0c770c;
    padding: 5px;
  }

  .pageTitle {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 1.3rem;
    color: #056839;
    padding: 0px;
    margin-left: 4px;
  }

  .info {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 0.8rem;
    color: #056839;
    overflow-wrap: normal;
    padding: 5px;
  }

  .terms {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: normal;
    font-size: 0.7rem;
    color: #056839;
    overflow-wrap: normal;
    padding: 4px;
    margin-left: 2px;
  }

  .pallets {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: normal;
    font-size: 0.7rem;
    font-style: italic;
    color: #292928;
    overflow-wrap: normal;
    padding-left: 12px;
    margin-bottom: 0px;
    margin-top: 0px;
  }

  .result {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 0.9rem;
    color: #080808;
    overflow-wrap: normal;
    margin-top: 5px;
    margin-left: 3px;
    padding: 5px;
    border-left: 4px solid #ec9a02;
  }

  .zoneinfo {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: normal;
    font-size: 0.8rem;
    color: #2c2b2b;
    overflow-wrap: normal;
    margin-top: 0px;
    margin-left: 0px;
    padding: 1px;
    border-left: 0px solid #ec9a02;
    border-right: 0px solid #ec9a02;
    border-top: 0px solid #ec9a02;
    border-bottom: 0px solid #ec9a02;
    border-radius: 0px;
    /* background-color: #056839; */
  }

  .zoneinfocrane {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: normal;
    font-size: 0.8rem;
    color: #070707;
    overflow-wrap: normal;
    margin-top: 0px;
    margin-left: 0px;
    padding-left: 4px;
    border-left: 4px solid #ec9a02;
  }

  .zoneinfodump {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: normal;
    font-size: 0.8rem;
    color: #070707;
    overflow-wrap: normal;
    margin-top: 0px;
    margin-left: 0px;
    padding-left: 4px;
    border-left: 4px solid #186ddd;
  }

  .zoneinfosplit {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: normal;
    font-size: 0.8rem;
    color: #070707;
    overflow-wrap: normal;
    margin-top: 0px;
    margin-left: 0px;
    padding-left: 4px;
    border-left: 4px solid #ce2340;
  }

  .surcharge {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: normal;
    font-size: 0.8rem;
    color: #8600b3;
    overflow-wrap: normal;
    margin-top: 0px;
    margin-left: 0px;
    padding-left: 4px;
    border-left: 4px solid #8600b3;
  }

  .surchargetotal {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: normal;
    font-size: 0.8rem;
    color: #8600b3;
    overflow-wrap: normal;
  }

  .deliveryzone {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 0.9rem;
    color: #070707;
    overflow-wrap: normal;
    margin-top: 0px;
    margin-left: 0px;
    padding-left: 4px;
    /* border-left: 4px solid #ce2340; */
  }

  .errorinfo {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 0.7rem;
    color: #c42626;
    overflow-wrap: normal;
    padding: 1px;
    /* border-left: 3px solid #c42626; */
  }

  .erroricon {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 1rem;
  }

  /*   
  input{
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    width: 100%;
    border: 1px solid #6b6d69;
    padding: 6px;
    margin: 5px
  } */

  .maskinput {
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    width: 100%;
    border: 1px solid #6b6d69;
    padding: 6px;
    margin: 5px;
  }

  /* textarea{
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    max-width: 97%;
    border: 1px solid #6b6d69;  
    padding: 6px;
    margin: 5px;
    min-width: 97%
  } */

  .inputLabel {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 0.9rem;
    color: #302f2f;
    overflow-wrap: normal;
    margin: 1px;
    padding-right: 4px;
    padding-top: 3px;
    padding-bottom: 2px;
  }

  /* select{
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    width: 100%;
    border: 1px solid #6b6d69;  
    padding: 5px;
    margin: 5px
  } */

  .quantities {
    display: -webkit-flex; /* Safari */
    -webkit-align-items: center; /* Safari 7.0+ */
    display: flex;
    align-items: center;
    margin-top: 7px;
  }

  /* .checkboxes label {
  display: inline-block;
  padding-right: 10px;
  white-space: nowrap;
} */
  /* .checkboxes input {
  vertical-align: middle;
}
.checkboxes label span {
  vertical-align: middle;
} */
  :root {
    --pure-material-primary-rgb: 5, 104, 57;
    --pure-material-onprimary-rgb: 255, 255, 255;
    --pure-material-surface-rgb: 255, 255, 255;
    --pure-material-onsurface-rgb: 0, 0, 0;
  }

  .pure-material-checkbox {
    z-index: 0;
    position: relative;
    display: inline-block;
    color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.87);
    font-family: var(
      --pure-material-font,
      "Roboto",
      "Segoe UI",
      BlinkMacSystemFont,
      system-ui,
      -apple-system
    );
    font-size: 16px;
    line-height: 1.5;
  }

  /* Input */
  .pure-material-checkbox > input {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    z-index: -1;
    position: absolute;
    left: -10px;
    top: -8px;
    display: block;
    margin: 0;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    /* background-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6); */
    background-color: #056839;
    box-shadow: none;
    outline: none;
    opacity: 0;
    transform: scale(1);
    pointer-events: none;
    transition: opacity 0.3s, transform 0.2s;
  }

  /* Span */
  .pure-material-checkbox > span {
    display: inline-block;
    width: 100%;
    cursor: pointer;
  }

  /* Box */
  .pure-material-checkbox > span::before {
    content: "";
    display: inline-block;
    box-sizing: border-box;
    margin: 3px 11px 3px 1px;
    border: solid 2px; /* Safari */
    border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
    border-radius: 2px;
    width: 18px;
    height: 18px;
    vertical-align: top;
    transition: border-color 0.2s, background-color 0.2s;
  }

  /* Checkmark */
  .pure-material-checkbox > span::after {
    content: "";
    display: block;
    position: absolute;
    top: 3px;
    left: 1px;
    width: 10px;
    height: 5px;
    border: solid 2px transparent;
    border-right: none;
    border-top: none;
    transform: translate(3px, 4px) rotate(-45deg);
  }

  /* Checked, Indeterminate */
  .pure-material-checkbox > input:checked,
  .pure-material-checkbox > input:indeterminate {
    /* background-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
    background-color: #056839;
  }

  .pure-material-checkbox > input:checked + span::before,
  .pure-material-checkbox > input:indeterminate + span::before {
    border-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
    background-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
  }

  .pure-material-checkbox > input:checked + span::after,
  .pure-material-checkbox > input:indeterminate + span::after {
    border-color: rgb(var(--pure-material-onprimary-rgb, 255, 255, 255));
  }

  .pure-material-checkbox > input:indeterminate + span::after {
    border-left: none;
    transform: translate(4px, 3px);
  }

  /* Hover, Focus */
  .pure-material-checkbox:hover > input {
    opacity: 0.04;
  }

  .pure-material-checkbox > input:focus {
    opacity: 0.12;
  }

  .pure-material-checkbox:hover > input:focus {
    opacity: 0.16;
  }

  /* Active */
  .pure-material-checkbox > input:active {
    opacity: 1;
    transform: scale(0);
    transition: transform 0s, opacity 0s;
  }

  .pure-material-checkbox > input:active + span::before {
    border-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
  }

  .pure-material-checkbox > input:checked:active + span::before {
    border-color: transparent;
    background-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  }

  /* Disabled */
  .pure-material-checkbox > input:disabled {
    opacity: 0;
  }

  .pure-material-checkbox > input:disabled + span {
    color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.38);
    cursor: initial;
  }

  .pure-material-checkbox > input:disabled + span::before {
    border-color: currentColor;
  }

  .pure-material-checkbox > input:checked:disabled + span::before,
  .pure-material-checkbox > input:indeterminate:disabled + span::before {
    border-color: transparent;
    background-color: currentColor;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 3px auto;
  }

  /* Zebra striping */
  tr:nth-of-type(odd) {
    background: rgb(255, 255, 255);
  }

  tr:nth-of-type(even) {
    background: rgb(255, 255, 255);
  }

  th {
    /* background: #056839; 
	color: white;  */
    background: #f5f2f2;
    color: #1b1b1b;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
  }

  td,
  th {
    padding: 5px;
    border: 1px solid #ccc;
    /* border-radius: 5px; */
    font-family: Arial, Helvetica, sans-serif;
    text-align: left;
    font-size: 14px;
  }

  /* 
Max width before this PARTICULAR table gets nasty
This query will take effect for any screen smaller than 760px
and also iPads specifically.
*/
  /* @media 
only screen and (max-width: 350px),
(min-device-width: 728px) and (max-device-width: 1024px)  {

	table { 
	  	width: 100%; 
	}

	
	table, thead, tbody, th, td, tr { 
		display: block; 
	}
	
	
	thead tr { 
		position: absolute;
		top: -9999px;
		left: -9999px;
	}
	
	tr { border: 1px solid #ccc; }
	
	td { 
		
		border: none;
		border-bottom: 1px solid #eee; 
		position: relative;
		padding-left: 50%; 
	}

	td:before { 
		
		position: absolute;
		
		top: 6px;
		left: 6px;
		width: 45%; 
		padding-right: 10px; 
		white-space: nowrap;
	
		content: attr(data-column);

		color: #000;
		font-weight: bold;
	}

} */

  .slider {
    -webkit-appearance: none;
    width: 85px;
    height: 10px;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    -webkit-transition: 0.2s;
    transition: opacity 0.2s;
  }

  .slider:hover {
    opacity: 1;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    background: #056839;
    cursor: pointer;
    border-radius: 50%;
  }

  .slider::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: #056839;
    cursor: pointer;
  }

  .userinfo {
        font-weight: bold;
        font-size: 1.4rem;
        /* color: #8d8d8c; */
        color: #1d1d1c;
        margin-top: 0px;
        margin-bottom: 0px;
        vertical-align: middle;
        /* border-bottom: 1px solid #535353; */
        padding-bottom: 2px;
        padding-left: 3px;
        padding-top: 3px;
        /* background-color: #f5f2f2; */
        background-color: transparent;
        border-radius: 0px;
    }
  .table-title {
    font-weight: bold;
    font-size: 1.2rem;
    padding-top: 3px;
    padding-left: 6px;
    margin-bottom: 0px;
  }

  .btns {
    padding-top: 2px;
  }

  .logo {
    vertical-align: middle;
    display: inline-flex;
  }
  .logo2 {
    max-height: 39px;
  }
</style>

<!-- <div class="mainContainer"> -->
<!-- <img src="https://res.cloudinary.com/landscape-centre-inc/image/upload/c_scale,w_120/v1544065561/landscapecentre-logo.png" alt="logo"> -->
<!-- <label class="pageTitle"> -->
<!-- Bulk Materials Quote -->
<!-- </label> -->
<!-- </div> -->
<!-- Auth View -->

<div class="mainContainer">
  <div class="sectionContainer column">
    <!-- <label class="sectionTitle">1. Delivery Zone</label> -->
    <div>
      {#if history.length > 0}
        <label for="historylist" class="inputLabel">History</label>

        <div class="select">
          <select
            id="historylist"
            bind:value={selectedhistory}
            on:change={loadSavedQuote}>
            <option value="" />
            {#each history as q}
              <option value={q.address2} selected={address2 === q.address2}>
                {q.address2}
              </option>
            {/each}
          </select>
        </div>
      {/if}

      <label for="autocomplete" class="inputLabel">
        {#if invalidAddress}🙁{/if}
        Delivery Address</label>
      <div class="control has-icons-left">
        <input
          class="input is-hovered"
          id="autocomplete"
          placeholder="Enter delivery address"
          on:focus={geolocate}
          type="text"
          required
          autocomplete="off" />
        <span class="icon is-small is-left">
          <i class="fas fa-map-marked-alt" />
        </span>
      </div>

      {#if addressfound}
        <div class="zoneinfo">
          <table id="address-info">
            <thead>
              <tr>
                <th>
                  <div class="deliveryzone">{deliveryzone}</div>
                </th>
                <th style="text-align: right">
                  <button
                    class="button is-small is-outlined button-color"
                    on:click={resetAddress}>
                    <span class="icon"> <i class="fas fa-times" /> </span>
                    <span>Reset</span>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="zoneinfocrane">
                    <span class="icon is-small is-left">
                      <i class="fas fa-shopping-bag" />
                    </span>
                    <b>Crane/Forklift Delivery Min</b>:
                  </div>
                  <!-- <div class="pallets">Price will increase depending on the number of pallets.</div> -->
                </td>
                <td style="text-align: right">
                  <b>{numeral(deliverycrane * 1.0).format('$0,0.00')}</b>
                  <!-- <div class="pallets">Minimum</div> -->
                </td>
              </tr>
              <tr>
                <td>
                  <div class="zoneinfodump">
                    <span class="icon is-small is-left">
                      <i class="fas fa-angle-up" />
                    </span>
                    <b>Dump Truck Delivery:</b>
                  </div>
                  <!-- <div class="pallets">Max 5 yards of heavy product, 8 yards of light product.</div> -->
                </td>
                <td style="text-align: right">
                  <b>{numeral(deliverysingle * 1.0).format('$0,0.00')}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="zoneinfosplit">
                    <span class="icon is-small is-left">
                      <i class="fas fa-angle-double-up" />
                    </span>
                    <b>Dump Truck Split Delivery:</b>
                  </div>
                  <!-- <div class="pallets">Max 5 yards of heavy product, 8 yards of light product. Divider is in the middle of the truck.</div> -->
                </td>
                <td style="text-align: right">
                  <b>{numeral(deliverysplit * 1.0).format('$0,0.00')}</b>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="surcharge">
                    <span class="icon is-small is-left">
                      <i class="fas fa-solid fa-gas-pump"></i>
                    </span>
                    <b>Price above is accurate and has {surchargetext} Fuel Surcharge 03/31/26</b>
                  </div>
                  <!-- <div class="pallets">Max 5 yards of heavy product, 8 yards of light product. Divider is in the middle of the truck.</div> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      {:else}<label> {addressnotfound} </label>{/if}
    </div>
  </div>
  <!-- in:fade out:fade -->
  {#if addressfound}
    <div class="sectionContainer" id="inputs" transition:fly={{ y: -200, duration: 800 }}>
      <!-- <label class="sectionTitle">2. Products</label> -->
      <div>
        <label for="pricelevel" class="inputLabel">
          {#if invalidProduct1}🙁{/if}
          Price Level</label>
        <div class="control has-icons-left">
          <div class="select">
            <select
              class="is-hovered"
              id="pricelevel"
              bind:value={pricelevel}
              required>
              <option value="1">Retail</option>
              <option value="0.9">Contractor</option>
            </select>
          </div>
          <div class="icon is-small is-left"><i class="fas fa-tag" /></div>
        </div>

        <div />
        <hr />

        <label for="product1" class="inputLabel">
          {#if invalidProduct1}🙁{/if}
          Bulk 1</label>
        <div class="control has-icons-left">
          <div class="select">
            <select
              class="is-hovered"
              id="product1"
              bind:value={product1}
              required>
              <option value="" />
              {#each materials as mat}
                <option value={mat.name} selected={ product1 === mat.name }>
                  {mat.description + ' @ ' + numeral(mat.price * pricelevel).format('$0.00')}
                </option>
              {/each}
            </select>
          </div>
          <div class="icon is-small is-left"><i class="fas fa-th-list" /></div>
        </div>
      </div>

      {#if product1 != ''}
        <div class="quantities">
          <label for="q1" class="inputLabel">
            {#if invalidQuantity1}🙁{/if}
            Bulk 1 Quantity</label>

          <!-- <input class="input" readonly type="number" pattern="[0-9\.]*" id="q1" min="0.5" step="0.5" bind:value={product1quantity} required style="max-width: 65px;"> -->
          <div class="select">
            <select
              class="is-hovered"
              id="product1qs"
              bind:value={product1quantity}
              required>
              {#each quantities as quantity}
                <option
                  value={quantity.qty}
                  selected={product1quantity === quantity.qty}>
                  {quantity.name}
                </option>
              {/each}
            </select>
          </div>
          <!-- <input name="s2" id="q1s" step="0.5" min="0.5" max="20" value="0" type="range" bind:value={product1quantity} style="max-width: 100px;"> -->
          <input
            type="range"
            id="q2s"
            min="0.5"
            step="0.5"
            max="20"
            bind:value={product1quantity}
            style="max-width: 100px;" />
        </div>
      {/if}

      {#if product1 != ''}
        <hr />
        <div in:fade out:fade>
          <div>
            <label for="product2" class="inputLabel">Bulk 2</label>
            <div class="control has-icons-left">
              <div class="select">
                <select
                  class="is-hovered"
                  id="product2"
                  bind:value={product2}
                  required>
                  <option value="" />
                  {#each materials as mat}
                    <option value={mat.name} selected={product2 === mat.name}>
                      {mat.description + ' @ ' + numeral(mat.price * pricelevel).format('$0.00')}
                    </option>
                  {/each}
                </select>
              </div>
              <div class="icon is-small is-left">
                <i class="fas fa-th-list" />
              </div>
            </div>
          </div>
          {#if product2 != ''}
            <div class="quantities">
              <label for="q2" class="inputLabel">
                {#if invalidQuantity2}🙁{/if}
                Bulk 2 Quantity</label>
              <!-- <input class="input" readonly type="number" pattern="[0-9\.]*" id="q2" min="0.5" step="0.5" bind:value={product2quantity} required style="max-width: 65px;"> -->
              <div class="select">
                <select
                  class="is-hovered"
                  id="product1q2s"
                  bind:value={product2quantity}
                  required>
                  {#each quantities as quantity}
                    <option
                      value={quantity.qty}
                      selected={product2quantity === quantity.qty}>
                      {quantity.name}
                    </option>
                  {/each}
                </select>
              </div>
              <input
                type="range"
                id="q2s"
                min="0.5"
                step="0.5"
                max="20"
                bind:value={product2quantity}
                style="max-width: 100px;" />
            </div>
          {/if}
        </div>
      {/if}

      {#if product1 != ''}
        <hr />
        <div in:fade out:fade>
          <div>
            <label for="product3" class="inputLabel">Misc</label>
            <div class="control has-icons-left">
              <div class="select">
                <select
                  class="is-hovered"
                  id="product3"
                  bind:value={product3}
                  required>
                  <option value="" />
                  {#each materialsmisc as mat}
                    <option value={mat.name} selected={product3 === mat.name}>
                      {mat.description + ' @ ' + numeral(mat.price * pricelevel).format('$0.00')}
                    </option>
                  {/each}
                </select>
              </div>
              <div class="icon is-small is-left">
                <i class="fas fa-th-list" />
              </div>
            </div>
          </div>
          {#if product3 != ''}
            <div class="quantities">
              <label for="q2" class="inputLabel">
                {#if invalidQuantity2}🙁{/if}
                Misc Quantity</label>
              <!-- <input class="input" readonly type="number" pattern="[0-9\.]*" id="q2" min="0.5" step="0.5" bind:value={product2quantity} required style="max-width: 65px;"> -->
              <div class="select">
                <select
                  class="is-hovered"
                  id="product3q3s"
                  bind:value={product3quantity}
                  required>
                  {#each quantitiesmisc as quantity}
                    <option
                      value={quantity.qty}
                      selected={product3quantity === quantity.qty}>
                      {quantity.name}
                    </option>
                  {/each}
                </select>
              </div>
              <input
                type="range"
                id="q3s"
                min="1"
                step="1"
                max="6"
                bind:value={product3quantity}
                style="max-width: 100px;" />
            </div>
          {/if}
        </div>
      {/if}

      <hr />

      {#if product1 != ''}
        <label class="pure-material-checkbox">
          <input type="checkbox" bind:checked={isbagged} />
          <span>Deliver In 1 Cubic Yard Bags</span>
        </label>
      {/if}

      {#if product1 != ''}
        <div class="control btns">
          <label for="notes" class="inputLabel">Notes</label>
          <textarea
            class="textarea is-hovered"
            id="notes"
            type="textarea"
            rows="2"
            bind:value={notes}
            placeholder="Notes" />
          <!-- <span class="icon is-small is-left"> <i class="fas fa-edit" /> </span> -->
        </div>
      {/if}

      <!-- in:fade out:fade -->
    </div>
    {#if product1 != ''}
      <div
        class="sectionContainer"
        id="results"
        transition:fly={{ y: -200, duration: 800 }}>

        <table id="order-details">
          <thead>
            <tr>
              <td colspan="3">
                <div class="logo">
                  <div class="logo2">
                    <img src="logo.png" width="80" height="46" alt="Landscape Centre"> 
                  </div>
                  <div class="table-title" >Bulk Delivery Quote</div></div>
              </td>
            </tr>
            <tr>
              <td colspan="3"><b>Date/Time: </b> {getDate()}</td>
            </tr>
            <tr>
              <td colspan="3"><b>Ship To: </b>{address2}</td>
            </tr>
            {#if notes !== ""}
              <tr>
                <td colspan="3">{notes}</td>
              </tr>
            {/if}
            <tr>
              <th>Description</th>
              <th style="text-align: right">Quantity</th>
              <th style="text-align: right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {#if product1 != ''}
              <tr>
                <td>
                  {product1 + ' @ ' + numeral(unitprice1).format('$0,0.00')}
                </td>
                <td style="text-align: right">{product1quantity}</td>
                <td style="text-align: right">
                  {numeral(product1price).format('$0,0.00')}
                </td>
              </tr>
            {/if}
            {#if product2 != ''}
              <tr>
                <td>
                  {product2 + ' @ ' + numeral(unitprice2).format('$0,0.00')}
                </td>
                <td style="text-align: right">{product2quantity}</td>
                <td style="text-align: right">
                  {numeral(product2price).format('$0,0.00')}
                </td>
              </tr>
            {/if}
            {#if product3 != ''}
              <tr>
                <td>
                  {product3 + ' @ ' + numeral(unitprice3).format('$0,0.00')}
                </td>
                <td style="text-align: right">{product3quantity}</td>
                <td style="text-align: right">
                  {numeral(product3price).format('$0,0.00')}
                </td>
              </tr>
            {/if}
            {#if singleloads > 0}
              <tr>
                <td>
                  <div class="zoneinfodump">
                    Delivery Single @
                    {numeral(deliverysingle).format('$0,0.00')}
                  </div>
                  <!-- <img src="https://res.cloudinary.com/landscape-centre-inc/image/upload/c_scale,dpr_auto,q_100,w_65/v1574891888/Truck-56-400x125.png" alt=""/> -->
                </td>
                <td style="text-align: right">{singleloads}</td>
                <td style="text-align: right">
                  {numeral(singletotal).format('$0,0.00')}
                </td>
              </tr>
            {/if}
            {#if splitloads > 0}
              <tr>
                <td>
                  <div class="zoneinfosplit">
                    Delivery Split @
                    {numeral(deliverysplit).format('$0,0.00')}
                  </div>
                  <!-- <img src="https://res.cloudinary.com/landscape-centre-inc/image/upload/c_scale,dpr_auto,q_100,w_65/v1574891888/Truck-56-400x125.png" alt=""/> -->
                </td>
                <td style="text-align: right">{splitloads}</td>
                <td style="text-align: right">
                  {numeral(splittotal).format('$0,0.00')}
                </td>
              </tr>
            {/if}
            {#if totalbags > 0}
              <tr>
                <td>
                  <div class="zoneinfocrane">
                    Bags @
                    {numeral(bagcost).format('$0,0.00')}
                  </div>
                  <div class="pallets">- Non-refundable</div>
                </td>
                <td style="text-align: right">{totalbags}</td>
                <td style="text-align: right">
                  {numeral(bagtotal).format('$0,0.00')}
                </td>
              </tr>
              <tr>
                <td>
                  <div class="zoneinfocrane">
                    Fill Charge @
                    {numeral(fillcharge).format('$0,0.00')}
                  </div>
                </td>
                <td style="text-align: right">{totalbags}</td>
                <td style="text-align: right">
                  {numeral(filltotal).format('$0,0.00')}
                </td>
              </tr>
              <tr>
                <td>
                  <div class="zoneinfocrane">
                    Pallet Deposits @
                    {numeral(palletdeposit).format('$0,0.00')}
                  </div>
                  <div class="pallets">- Refundable within 30 days</div>
                </td>
                <td style="text-align: right">{totalbags}</td>
                <td style="text-align: right">
                  {numeral(pallettotal).format('$0,0.00')}
                </td>
              </tr>
              <tr>
                <td>
                  <div class="zoneinfocrane">Delivery Crane/Forklift</div>
                  <!-- <span><img src="https://res.cloudinary.com/landscape-centre-inc/image/upload/c_scale,dpr_auto,q_100,w_75/v1574891888/Truck-54-400x125.png" alt=""/> -->
                  <!-- <img src="https://res.cloudinary.com/landscape-centre-inc/image/upload/c_scale,dpr_auto,q_100,w_100/v1574891888/Truck-61-400x125.png" alt=""/></span> -->
                </td>
                <td style="text-align: right" />
                <td style="text-align: right">
                  {numeral(delivery).format('$0,0.00')}
                </td>
              </tr>
            {/if}
            {#if deliverySurcharge != 0}
              <tr>
                <td>
                  <div class="surcharge">
                    <b>Fuel Surcharge @ {surchargetext}</b>
                  </div>
                </td>
                <td style="text-align: right"></td>
                <td class="surchargetotal" style="text-align: right">
                  <b>{numeral(deliverySurcharge).format('$0,0.00')}</b>
                </td>
              </tr>
            {/if}
            <tr>
              <td />
              <td style="text-align: right"><b>Subtotal</b></td>
              <td style="text-align: right">
                <b>{numeral(subtotal).format('$0,0.00')}</b>
              </td>
            </tr>
            <tr>
              <td />
              <td style="text-align: right"><b>GST</b></td>
              <td style="text-align: right">
                {numeral(gst).format('$0,0.00')}
              </td>
            </tr>
            <tr>
              <td />
              <td style="text-align: right"><b>PST</b></td>
              <td style="text-align: right">
                {numeral(pst).format('$0,0.00')}
              </td>
            </tr>
            <tr>
              <td/>
              <td style="text-align: right"><b>Total</b></td>
              <td style="text-align: right">
                <b>{numeral(totalprice).format('$0,0.00')}</b>
              </td>
            </tr>
            <tr>
              <td colspan="3"><small>{terms}</small></td>
            </tr>
            <tr>
              <td colspan="3" class="terms">&copy; {fullyear} Landscape Centre Inc.</td>
            </tr>
          </tbody>
        </table>
        <div class="btns" id="buttons">

          <div class="btns">
            <button
              name="but1"
              id="but1"
              class="button is-small is-outlined button-color"
              on:click={() => printQuote('print')}>
              <span class="icon"> <i class="fas fa-print" /> </span>
              <span>Print</span>
            </button>
            <button
              class="button is-small is-outlined button-color"
              on:click={() => printQuote('save')}>
              <span class="icon"> <i class="fas fa-save" /> </span>
              <span>PDF</span>
            </button>
            <button
              class="button is-small is-outlined button-color"
              on:click={() => saveAsImage()}>
              <span class="icon"> <i class="fas fa-image" /> </span>
              <span>Image</span>
            </button>
            <button
              class="button is-small is-outlined button-color"
              on:click={() => copyTable( document.getElementById('order-details'))}>
              <span class="icon"> <i class="fas fa-copy" /> </span>
              <span>Copy</span>
            </button>
          </div>

        </div>
      </div>
    {/if}
  {/if}
  {#if addressfound}
    <div
      id="map"
      class="mapContainer"
      transition:fly={{ y: -200, duration: 800 }} />
  {/if}
</div>

<!-- {#if addressfound}
  <div class="mainContainer">
    <div id="map" class="mapContainer" in:fade out:fade></div>
  </div>
{/if} -->

<div class="mainContainer2">
  <label class="terms">&copy;
    {fullyear}
    Landscape Centre Inc. -
    {version}</label>
</div>
